$( function() {
	$( 'input' ).iCheck();

	$( '.email-form' ).on( 'click', function( clickEvent ) {
		if ( !$( this ).find( '.g-recaptcha' ).length ) {
			$( '.g-recaptcha-placeholder' ).removeClass( 'active' );

			var repcatcha = $( '.g-recaptcha' ).detach();
			repcatcha.appendTo( $( this ).find( '.g-recaptcha-placeholder' ) );
		}

		$( '.g-recaptcha-placeholder' ).addClass( 'active' );

	} );

	$( '.email-form' ).on( 'submit', function( submitEvent ) {
		submitEvent.preventDefault();

		var form = $( this );
		var responseContainer = form.find( '.response-container' );
		var responseElement = form.find( '.response' );

		var serializedData = form.serializeArray();

		for ( var index = 0; index < serializedData.length; index++ ) {
			var currentElement = form.find( '[name="' + serializedData[ index ].name + '"]' );
			serializedData[ index ].required = currentElement.attr( 'required' );
			serializedData[ index ].name = currentElement.attr( 'name' );
			serializedData[ index ].id = currentElement.attr( 'id' );
		}

		responseContainer.addClass( 'active' );

		var formData = {
			action: 'formsubmit',
			data: serializedData,
		};

		var formSuccess = function( response ) {
			responseContainer.addClass( 'active' );
			responseElement.html( response.message );
			if ( response.returnCode === R.id.validForm ) {
				form.find( 'input, textarea' ).not( ':submit, :hidden,:checkbox' ).val( '' );
				form.find( ':checkbox' ).prop( 'checked', false );
				form.find( '.icheckbox' ).removeClass( 'checked' );
				grecaptcha.reset();
				$( '.g-recaptcha-placeholder' ).removeClass( 'active' );
			} else {
				responseContainer.addClass( 'active' );
				responseElement.html( response.message );
				grecaptcha.reset();
			}
		};

		formSubmit( formData, formSuccess, responseElement );
	} );
} );

function formSubmit( formData, success, responseElement ) {
	responseElement.show().html( R.string.serverCommunication );

	$.ajax( {
		type: 'POST',
		dataType: 'json',
		url: wpAjaxUrl,
		data: formData,
		success: success,
	} );
}
